module.exports = __webpack_public_path__ + "static/media/join_contest_icon.8509bba1.svg";